import React, { PropsWithChildren, useContext } from "react";

type RateBuilderStausContextValue = { mode: 'view' | 'edit'; isRevision?: boolean; archived?: boolean; draft?: boolean };
const RateBuilderStatusContext = React.createContext<RateBuilderStausContextValue>({
  mode: 'edit',
  isRevision: false,
  archived: false,
  draft: false,
});
RateBuilderStatusContext.displayName = "RateBuilderStatus";

export const RateBuilderStatusProvider = ({
  children,
  mode,
  isRevision,
  archived,
  draft,
}: PropsWithChildren<RateBuilderStausContextValue>) => (
  <RateBuilderStatusContext.Provider value={{ mode: mode, isRevision, archived, draft }}>
    {children}
  </RateBuilderStatusContext.Provider>
);

export function useRateBuilderStatus(): RateBuilderStausContextValue {
  return useContext(RateBuilderStatusContext);
}
